import * as regionsList from './statesList'

export const mxTaxSystemOptions = [
  '601 (General de Ley Personas Morales)',
  '603 (Personas Morales con Fines no Lucrativos)',
  '605 (Sueldos y Salarios e Ingresos Asimilados a Salarios)',
  '606 (Arrendamiento)',
  '607 (Régimen de Enajenación o Adquisición de Bienes)',
  '608 (Demás ingresos)',
  '609 (Consolidación)',
  '610 (Residentes en el Extranjero sin Establecimiento Permanente en México)',
  '611 (Ingresos por Dividendos (socios y accionistas))',
  '612 (Personas Físicas con Actividades Empresariales y Profesionales)',
  '614 (Ingresos por intereses)',
  '615 (Régimen de los ingresos por obtención de premios)',
  '616 (Sin obligaciones fiscales)',
  '620 (Sociedades Cooperativas de Producción que optan por diferir sus ingresos)',
  '621 (Incorporación Fiscal)',
  '622 (Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras)',
  '623 (Opcional para Grupos de Sociedades)',
  '624 (Coordinados)',
  '625 (Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas)',
  '626 (Régimen Simplificado de Confianza)',
  '628 (Hidrocarburos)',
  '629 (De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales)',
  '630 (Enajenación de acciones en bolsa de valores)',
].map((option) => ({ value: option, label: option }))

export const clearVATNumber = (value: string, country: string): string => {
  return value.toUpperCase().replace(/[^A-Z0-9]/g, '')
}

export const statesOptions = (country: 'us' | 'mx') => {
  const list = regionsList[country]

  if (!list) return []
  return list.map((state: string) => ({
    label: state,
    value: state,
  }))
}

export const getVATAbbreviationByCountry = (country: string): string => {
  const vatAbbreviations: { [key: string]: string } = {
    AT: 'UID',
    BE: 'TVA',
    BG: 'ДДС',
    HR: 'PDV-ID; OIB',
    CY: 'ΦΠΑ',
    CZ: 'DIČ',
    DK: 'CVR',
    EE: 'KMKR',
    FI: 'ALV nro Momsnummer',
    FR: 'TVA',
    DE: 'USt-IdNr.',
    EL: 'ΦΠΑ',
    GR: 'ΦΠΑ',
    HU: 'ANUM',
    IE: 'VAT / CBL',
    IT: 'P.IVA',
    LV: 'PVN',
    LT: 'PVM kodas',
    LU: 'TVA',
    MT: 'Vat No.',
    NL: 'BTW-ID.',
    PL: 'NIP',
    PT: 'NIF / NIPC',
    RO: 'CIF',
    SK: 'IČ DPH',
    SI: 'ID za DDV',
    ES: 'NIF / CIF',
    SE: 'Momsnr.',
    AL: 'NUIS',
    AU: 'ABN',
    BY: 'УНП (UNP)',
    BA: 'JIB',
    CA: 'BN / NE',
    CN: '統一社會信用代碼',
    CH: 'UID / VAT',
    IS: 'VSK / VASK',
    IN: 'GSTIN',
    ID: 'NPWP',
    IL: 'REG/VAT ID',
    JP: '法人編號',
    KZ: 'БСН / ЖСН',
    NZ: 'GST / IRD',
    NG: 'VAT',
    MK: 'ЕДБ',
    NO: 'Orgnr',
    PH: 'TIN',
    RU: 'ИНН',
    SM: 'C.O.E.',
    SA: 'TIN',
    RS: 'PIB',
    TW: '統編',
    TR: 'VKN',
    UA: 'ІНПП',
    GB: 'VAT Reg No',
    UZ: 'СТИР',
    AR: 'CUIT',
    BO: 'NIT',
    BR: 'CNPJ or CPF',
    CL: 'RUT',
    CO: 'NIT',
    CR: 'Cédula Jurídica',
    DO: 'RNC',
    EC: 'RUC',
    SV: 'NIT',
    GT: 'NIT',
    HN: 'RTN',
    MX: 'RFC',
    NI: 'RUC',
    PA: 'RUC',
    PY: 'RUC',
    PE: 'RUC',
    UY: 'RUT',
    VE: 'RIF',
    US: 'IEN',
  }

  const abbreviation = vatAbbreviations[country.toUpperCase()]
  return abbreviation || 'VAT'
}
